var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "overlay-modal",
    {
      ref: "overlayModal",
      staticClass: "without-header",
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function() {
            return [
              _c("div", [
                _c(
                  "h4",
                  {
                    staticClass: "cursive mb-0",
                    staticStyle: { "line-height": "40px" }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.isTrasferimento ? "Trasferimenti" : "Attività")
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-flex justify-content-between p-2" },
                  [
                    _c("div", [
                      _c(
                        "span",
                        {
                          staticClass: "text-uppercase",
                          staticStyle: { "line-height": "32px" }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.listFiltered.length) +
                              " " +
                              _vm._s(
                                _vm.isTrasferimento
                                  ? "trasferimenti trovati"
                                  : "attività trovate"
                              )
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm.mode === 1
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-secondary btn-sm py-1 px-4",
                              attrs: { href: "javascript:void(0)" },
                              on: {
                                click: function($event) {
                                  _vm.mode = 2
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("../../../../assets/images/svg/white/icone_mappa.svg"),
                                  height: "24px"
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-uppercase" }, [
                                _vm._v("mappa")
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.mode === 2
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-secondary btn-sm py-1 px-4",
                              attrs: { href: "javascript:void(0)" },
                              on: {
                                click: function($event) {
                                  _vm.mode = 1
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("../../../../assets/images/svg/white/icone_lista.svg"),
                                  height: "24px"
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-uppercase" }, [
                                _vm._v("lista")
                              ])
                            ]
                          )
                        : _vm._e()
                    ])
                  ]
                )
              ])
            ]
          },
          proxy: true
        },
        {
          key: "footer",
          fn: function() {
            return [
              _c(
                "div",
                {
                  staticClass:
                    "menu-footer d-flex justify-content-between bg-dark"
                },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-between px-2 py-1" },
                    [
                      _c("div", { on: { click: _vm.onOpenCloseFilter } }, [
                        _c(
                          "p",
                          {
                            staticClass: "mb-0",
                            staticStyle: { "line-height": "30px" }
                          },
                          [
                            _c("b", [_vm._v("Filtra risultati")]),
                            _c("span", [_vm._v(" | " + _vm._s(_vm.counter))])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-sm btn-secondary mt-1",
                            attrs: { disabled: _vm.isDisabledReset },
                            on: { click: _vm.onResetFilter }
                          },
                          [_vm._v("reset")]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          on: {
                            mouseleave: function($event) {
                              _vm.openFilter = false
                            }
                          }
                        },
                        [
                          _c("DropdownFilterService", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.openFilter,
                                expression: "openFilter"
                              }
                            ],
                            attrs: {
                              "is-trasferimento": _vm.isTrasferimento,
                              list: _vm.list,
                              value: _vm.getFilter
                            },
                            on: { close: _vm.onOpenCloseFilter }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("CustomOrderSelect", {
                        staticClass: "lg",
                        attrs: { list: _vm.order },
                        on: { change: _vm.onChangeOrder }
                      })
                    ],
                    1
                  )
                ]
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      [
        _c("div", { staticClass: "modal-map" }, [
          _c("div", [
            _vm.mode === 1
              ? _c("div", [
                  _c(
                    "div",
                    {
                      staticClass: "tasks pb-5",
                      style: "height: " + _vm.windowHeight + "px;"
                    },
                    _vm._l(_vm.listFiltered, function(item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          on: {
                            mouseover: function($event) {
                              return _vm.onMouseHover(item)
                            }
                          }
                        },
                        [
                          _c("ServicePanel", {
                            staticClass: "mb-3",
                            attrs: {
                              "is-trasferimento": _vm.isTrasferimento,
                              "is-from-modal-map": true,
                              value: item,
                              selected: _vm.isSelected(item)
                            },
                            on: {
                              select: _vm.onSelectService,
                              detail: _vm.onShowDetail
                            }
                          })
                        ],
                        1
                      )
                    }),
                    0
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.mode === 2,
                    expression: "mode === 2"
                  }
                ],
                staticClass: "p-0"
              },
              [
                _c(
                  "GmapMap",
                  {
                    ref: "mapRef",
                    staticClass: "map",
                    style: "height: " + (_vm.windowHeight - 70 - 63) + "px;",
                    attrs: {
                      options: {
                        zoomControl: true,
                        mapTypeControl: false,
                        scaleControl: true,
                        streetViewControl: true,
                        rotateControl: true,
                        fullscreenControl: true,
                        disableDefaultUi: false
                      },
                      center: _vm.center,
                      zoom: _vm.zoom,
                      "map-type-id": "terrain"
                    }
                  },
                  _vm._l(_vm.markers, function(m, index) {
                    return _c(
                      "gmap-custom-marker",
                      {
                        key: index,
                        attrs: {
                          offsetY: -10,
                          "z-index": m.zIndex,
                          marker: m,
                          alignment: "top"
                        },
                        nativeOn: {
                          click: function($event) {
                            return _vm.onSelectMarker(m)
                          }
                        }
                      },
                      [
                        _c("CustomServiceMarker", {
                          attrs: { value: m, hover: _vm.selectedItem }
                        })
                      ],
                      1
                    )
                  }),
                  1
                )
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          [
            _vm.selectedItem
              ? _c("ModalServiceDetail", {
                  ref: "modalServiceDetail",
                  attrs: {
                    "is-trasferimento": _vm.isTrasferimento,
                    value: _vm.selectedItem
                  },
                  on: { change: _vm.onChangeServiceGroup }
                })
              : _vm._e()
          ],
          1
        )
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75cf227e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75cf227e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/common/modals/ModalServicesMobileMap.vue
// module id = null
// module chunks = 